import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Paper,
  Grid,
  MenuItem,
  IconButton,
  InputAdornment,
  FormControl,
  FormLabel,
  Snackbar,
  Alert,
  Collapse, Divider
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { hosturl } from '../libs/Constant';
import EditIcon from '@mui/icons-material/Edit';
import Colors from '../libs/Colors';
const EditForm = ({ formData, fetchFormDetails }) => {
  const token = localStorage.getItem('token');
  const [formDataState, setFormDataState] = useState({
    fileNumber: '',
    receivedDate: dayjs(),
    memoNumber: '',
    officeNumber: '',
    receiveFrom: '',
    applicantName: '',
    subject: '',
    section: '',
    applicantPhoneNumber: [{ name: '', number: '' }],
    applicantMail: '',
    managementPhoneNumber: [{ name: '', number: '' }],
    managementMail: '',
    remarks: [{ date: dayjs(), text: '' }],
    url: '',
    applicantAddress: '',
    managementAddress: '',
    nextDateOfHearing: null,
    finalStatus: '',
    amount: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [receiveFromOptions, setReceiveFromOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [showAllFields, setShowAllFields] = useState(false);
  console.log("formdata",formDataState)
  useEffect(() => {
    fetchReceiveFromEntries();
    fetchSectionEntries();
  }, []);

useEffect(() => {
  if (formData) {
    const transformedData = {
      ...formData,
      receivedDate: formData.receivedDate ? dayjs(formData.receivedDate) : dayjs(),
      nextDateOfHearing: formData.nextDateOfHearing ? dayjs(formData.nextDateOfHearing) : null,
      applicantPhoneNumber: formData.applicantPhoneNumber.length > 0 ? formData.applicantPhoneNumber : [{ name: '', number: '' }],
      managementPhoneNumber: formData.managementPhoneNumber.length > 0 ? formData.managementPhoneNumber : [{ name: '', number: '' }],
      remarks:
        formData.remarks && formData.remarks.length > 0
          ? formData.remarks.map(remark => ({
              ...remark,
              date: remark.date ? dayjs(remark.date) : dayjs(),
              text: remark.text ?? ''  // also ensure text is at least empty string if null
            }))
          : [{ date: dayjs(), text: '' }],  // fallback for empty or missing remarks
    };
    setFormDataState(transformedData);
    setShowAllFields(transformedData.section === 'JM');
  }
}, [formData]);


  const fetchReceiveFromEntries = async () => {
    try {
      const response = await fetch(`${hosturl}/receive-from`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setReceiveFromOptions(data.result || []);
    } catch (err) {
      console.error('Receive From fetch error:', err);
    }
  };

  const fetchSectionEntries = async () => {
    try {
      const response = await fetch(`${hosturl}/section`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setSectionOptions(data.result || []);
    } catch (err) {
      console.error('Section fetch error:', err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataState(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (name, value) => {
    setFormDataState(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePhoneNumberChange = (index, field, value, type) => {
    const updatedArray = [...formDataState[type]];
    updatedArray[index][field] = value;
    setFormDataState(prev => ({
      ...prev,
      [type]: updatedArray
    }));
  };

  const handleAddPhoneNumber = (type) => {
    setFormDataState(prev => ({
      ...prev,
      [type]: [...prev[type], { name: '', number: '' }]
    }));
  };

  const handleRemovePhoneNumber = (index, type) => {
    const updatedArray = [...formDataState[type]];
    updatedArray.splice(index, 1);
    setFormDataState(prev => ({
      ...prev,
      [type]: updatedArray
    }));
  };

  const handleRemarkChange = (index, field, value) => {
    const updatedRemarks = [...formDataState.remarks];
    if (field === 'date') {
      updatedRemarks[index].date = value;
    } else {
      updatedRemarks[index].text = value;
    }
    setFormDataState(prev => ({
      ...prev,
      remarks: updatedRemarks
    }));
  };

  const handleAddRemark = () => {
    setFormDataState(prev => ({
      ...prev,
      remarks: [...prev.remarks, { date: dayjs(), text: '' }]
    }));
  };

  const handleRemoveRemark = (index) => {
    const updatedRemarks = [...formDataState.remarks];
    updatedRemarks.splice(index, 1);
    setFormDataState(prev => ({
      ...prev,
      remarks: updatedRemarks
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      setError('');

      // Format dates to ISO string
      const payload = {
        ...formDataState,
        receivedDate: formDataState.receivedDate.toISOString().split('T')[0],
        nextDateOfHearing: formDataState.nextDateOfHearing ? 
          formDataState.nextDateOfHearing.toISOString().split('T')[0] : null,
        remarks: formDataState.remarks.map(remark => ({
          ...remark,
          date: remark.date.toISOString().split('T')[0]
        }))
      };

      const response = await fetch(`${hosturl}/form/${formDataState._id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update form');
      }

      setSuccess(true);
      if (fetchFormDetails) await fetchFormDetails();
      window.location.reload()
    } catch (err) {
      setError(err.message || 'An error occurred while updating the form');
    } finally {
      setLoading(false);
    }
  };

  const statusOptions = [
     'Open',
    'Forwarded',
    'Closed',
  ];

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Paper elevation={3} sx={{ p: 2, mt: 4 }}>
         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
        <EditIcon color="primary" sx={{ fontSize: 25, mr: 2 }} />
        <Typography 
          variant="h5"
          component="h5"
          sx={{
            fontWeight: 700,
            color: 'primary.main',
            letterSpacing: '0.05em',
            position: 'relative'
          }}
        >
          Edit Form Details
        </Typography>
      </Box>
          
      <Divider sx={{ my: 3, borderColor:Colors.primaryColor1, borderWidth:1.5 }} />
          <Box component="form" sx={{ mt: 3 }}>
            <Grid container spacing={3}>
              {/* Basic Information */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="File Number"
                  name="fileNumber"
                  value={formDataState.fileNumber}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <DatePicker
                  label="Received Date"
                  value={formDataState.receivedDate}
                  onChange={(date) => handleDateChange('receivedDate', date)}
                  renderInput={(params) => <TextField fullWidth {...params} required />}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Memo Number"
                  name="memoNumber"
                  value={formDataState.memoNumber}
                  onChange={handleChange}
                  required
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  select
                  label="Received From"
                  name="receiveFrom"
                  value={formDataState.receiveFrom}
                  onChange={handleChange}
                  required
                >
                  {receiveFromOptions.map((option) => (
                    <MenuItem key={option._id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
                <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Subject"
                  name="subject"
                  value={formDataState.subject}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
             
               <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  select
                  label="Section"
                  name="section"
                  value={formDataState.section}
                  onChange={handleChange}
                  required
                >
                  {sectionOptions.map((option) => (
                    <MenuItem key={option._id} value={option.name}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              
              {/* Applicant Information */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Applicant Information
                </Typography>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Applicant Name"
                  name="applicantName"
                  value={formDataState.applicantName}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <FormLabel>Applicant Phone Numbers</FormLabel>
                  {formDataState.applicantPhoneNumber.map((phone, index) => (
                    <Grid container spacing={2} key={index} alignItems="center" sx={{ mt: 1 }}>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          label="Name"
                          value={phone.name}
                          onChange={(e) => handlePhoneNumberChange(index, 'name', e.target.value, 'applicantPhoneNumber')}
                          required
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          label="Phone Number"
                           inputProps={{ maxLength: 10, inputMode: 'numeric' }}
                          value={phone.number}
                           onChange={(e) => {
                              // Optional: Only allow digits
                              const val = e.target.value.replace(/\D/g, '');
                              handlePhoneNumberChange(index, 'number', val, 'applicantPhoneNumber');
                            }}
                          // onChange={(e) => handlePhoneNumberChange(index, 'number', e.target.value, 'applicantPhoneNumber')}
                          required
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <IconButton onClick={() => handleRemovePhoneNumber(index, 'applicantPhoneNumber')}>
                          <RemoveCircleOutlineIcon color="error" />
                        </IconButton>
                        {index === formDataState.applicantPhoneNumber.length - 1 && (
                          <IconButton onClick={() => handleAddPhoneNumber('applicantPhoneNumber')}>
                            <AddCircleOutlineIcon color="primary" />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </FormControl>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Applicant Email"
                  name="applicantMail"
                  type="email"
                  value={formDataState.applicantMail}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Applicant Address"
                  name="applicantAddress"
                  value={formDataState.applicantAddress}
                  onChange={handleChange}
                  required
                  multiline
                  rows={2}
                />
              </Grid>
              
              {/* Management Information */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Management Information
                </Typography>
              </Grid>
              
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="management Name"
                  name="managementName"
                  value={formDataState.managementName}
                  onChange={handleChange}
                  required
                />
              </Grid>
                  <FormLabel style={{marginTop:20}}>Management Phone Numbers</FormLabel>
                  {formDataState.managementPhoneNumber.map((phone, index) => (
                    <Grid container spacing={2} key={index} alignItems="center" sx={{ mt: 1 }}>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          label="Name"
                          value={phone.name}
                          onChange={(e) => handlePhoneNumberChange(index, 'name', e.target.value, 'managementPhoneNumber')}
                          required
                        />
                      </Grid>
                      <Grid item xs={5}>
                     <TextField
                            fullWidth
                            label="Phone Number"
                            type="text"
                            value={phone.number}
                            inputProps={{ maxLength: 10, inputMode: 'numeric' }}
                            onChange={(e) => {
                              // Optional: Only allow digits
                              const val = e.target.value.replace(/\D/g, '');
                              handlePhoneNumberChange(index, 'number', val, 'managementPhoneNumber');
                            }}
                            required
                          />

                      </Grid>
                      <Grid item xs={2}>
                        <IconButton onClick={() => handleRemovePhoneNumber(index, 'managementPhoneNumber')}>
                          <RemoveCircleOutlineIcon color="error" />
                        </IconButton>
                        {index === formDataState.managementPhoneNumber.length - 1 && (
                          <IconButton onClick={() => handleAddPhoneNumber('managementPhoneNumber')}>
                            <AddCircleOutlineIcon color="primary" />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </FormControl>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Management Email"
                  name="managementMail"
                  type="email"
                  value={formDataState.managementMail}
                  onChange={handleChange}
                  required
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Management Address"
                  name="managementAddress"
                  value={formDataState.managementAddress}
                  onChange={handleChange}
                  required
                  multiline
                  rows={2}
                />
              </Grid>
              
              {/* Additional Information */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Additional Information
                </Typography>
              </Grid>
              
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <FormLabel>Remarks</FormLabel>
                  {formDataState.remarks.map((remark, index) => (
                    <Grid container spacing={2} key={index} alignItems="center" sx={{ mt: 1 }}>
                      <Grid item xs={3}>
                        <DatePicker
                          label="Date"
                          value={remark.date}
                          onChange={(date) => handleRemarkChange(index, 'date', date)}
                          renderInput={(params) => <TextField fullWidth {...params}  />}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <TextField
                          fullWidth
                          label="Remark Text"
                          value={remark.text}
                          onChange={(e) => handleRemarkChange(index, 'text', e.target.value)}
                          required
                          multiline
                        />
                      </Grid>
                      <Grid item xs={1}>
                        <IconButton onClick={() => handleRemoveRemark(index)}>
                          <RemoveCircleOutlineIcon color="error" />
                        </IconButton>
                        {index === formDataState.remarks.length - 1 && (
                          <IconButton onClick={handleAddRemark}>
                            <AddCircleOutlineIcon color="primary" />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </FormControl>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="URL"
                  name="url"
                  value={formDataState.url}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">https://</InputAdornment>,
                  }}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <DatePicker
                  label="Next Date of Hearing"
                  value={formDataState.nextDateOfHearing}
                  onChange={(date) => handleDateChange('nextDateOfHearing', date)}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  select
                  label="Final Status"
                  name="finalStatus"
                  value={formDataState.finalStatus}
                  onChange={handleChange}
                >
                  {statusOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Amount recovered"
                  name="amount"
                  value={formDataState.amount}
                  onChange={handleChange}
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                  }}
                />
              </Grid>
              
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={handleSave}
                  disabled={loading}
                  sx={{ mt: 2 }}
                >
                  {loading ? 'Saving...' : 'Save Changes'}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
        
        {/* Success and Error notifications */}
        <Snackbar
      open={success}
      autoHideDuration={6000}
      onClose={() => setSuccess(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={() => setSuccess(false)} severity="success" sx={{ width: '100%' }}>
        Form updated successfully!
      </Alert>
    </Snackbar>

    <Snackbar
      open={!!error}
      autoHideDuration={6000}
      onClose={() => setError('')}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={() => setError('')} severity="error" sx={{ width: '100%' }}>
        {error}
      </Alert>
    </Snackbar>

      {/* </Container> */}
    </LocalizationProvider>
  );
};

export default EditForm;